import { features } from 'reactApp/mail-features';

const defaultImapTariffsList = [
    'W1GB_1m_imap_block_low',
    'W1GB_1y_imap_block_low',
    'W1GB_1m_imap_block_mid',
    'W1GB_1y_imap_block_mid',
    'W1GB_1m_imap_block_high',
    'W1GB_1y_imap_block_high',
];

const ImapAllTariffsList = features.getAsArray('imap-all-tariffs') || [];

export const ImapTariffsList = [...new Set([...defaultImapTariffsList, ...ImapAllTariffsList])];
